module.exports = __webpack_public_path__ + "img/logocortado.fd3e660c.png";